import React, { Component } from "react";
import { connect } from "react-redux";
import { TaskDetailsWrapper } from "./TOTaskDetails.style";
import { Modal, Table } from "antd";

export class TOTaskDetails extends Component {
  state = {
    viewModal: false,
  };
  render() {
    const columns = [
      {
        title: "Product Name",
        dataIndex: "productName",
        key: "productName",
        align: "center",
      },
      {
        title: "Batch Number",
        dataIndex: "batchNumber",
        key: "batchNumber",
        align: "center",
      },
      {
        title: "Bin Number",
        dataIndex: "binNumber",
        key: "binNumber",
        align: "center",
      },
      {
        title: "Bin Location",
        dataIndex: "binLocation",
        key: "binLocation",
        align: "center",
      },
      {
        title: "Picked Qty",
        dataIndex: "quantity",
        key: "quantity",
        align: "center",
      },
    ];

    return (
      <TaskDetailsWrapper>
        <button
          className="bbtn"
          onClick={async () => {
            await this.props.apiCall();
            await this.setState({
              viewModal: true,
            });
          }}
        >
          View Task Details
        </button>

        <Modal
          title={"Task Details"}
          open={this.state.viewModal}
          centered
          footer={null}
          onCancel={() => this.setState({ viewModal: false })}
        >
          <Table
            width={500}
            scroll={{ x: 650 }}
            dataSource={this.props.data}
            columns={columns}
          />
        </Modal>
      </TaskDetailsWrapper>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TOTaskDetails);
